import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart, BarChart, CandlestickChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    TitleComponent,
    TimelineComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    VisualMapComponent,
    VisualMapContinuousComponent,
    VisualMapPiecewiseComponent,
} from 'echarts/components';
import {
    CanvasRenderer,
} from 'echarts/renderers';


echarts.use(
    [VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, TitleComponent, TooltipComponent, GridComponent, LineChart, CandlestickChart, CanvasRenderer, DataZoomComponent,
        DataZoomInsideComponent, DataZoomSliderComponent, MarkPointComponent, MarkLineComponent, TimelineComponent,
        LegendComponent, MarkAreaComponent, BarChart]
);


const useStyles = makeStyles(theme => ({
    table: {
        // minWidth: 650,
    },
    root1: {
        flexGrow: 1,
    },
    menuButton: {
        // marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    grid: {
        // width: `calc(100% + ${6 + (theme.spacing(1))}px)`
    }
}));



export default function BuySellChart1(props) {
    const classes = useStyles();
    const theme = useTheme();

    const [option, setOption] = React.useState(null);

    function genoption1() {
        let k = {
            animation: false,
            title: [
                {
                    left: 'left',
                    text: props.title,
                    textStyle: {
                        fontSize: 12
                    },
                    // top: 0
                }],
            grid: [{
                top: props.top !=null?props.top: 29,
                left: 5,
                right: 5,
                // height: 100,
                bottom: 0,
                containLabel: true
            }],
            xAxis: [{
                type: 'category',
                boundaryGap: false,
                data: props.data.map(row => row.x),
            }],
            yAxis: [{
                scale: true,
                type: 'value',
                position: 'left',
                show: true,
                splitLine: {
                    show: true,
                    lineStyle: {
                        opacity: 0.2
                    }
                }
            }],
            visualMap: [
                {
                    show: false,
                    type: 'piecewise',
                    seriesIndex: 0,
                    min: -90000,
                    max: 90000,
                    pieces: [
                        { min: -90000, max: 0, color: '#78b7c2' },
                        { min: 0, max: 90000, color: "#ffaf38" },
                    ]
                },
            ],
            series: [
                {
                    name: '買賣超',
                    type: 'bar',
                    data: props.data.map(row => row.b),
                    smooth: true,
                    showSymbol: false,
                }
            ]
        };
        return k;
    }

    useEffect(() => {
        // fetchData()
        if (props.data != null) setOption(genoption1)
    }, []);

    const clickDetail = () => {
        if (props.setOpen != null) props.setOpen(true)
    }

    return (
        <div style={{ padding: 1 }} onClick={e => clickDetail()}>
            {option != null ?
                <ReactEChartsCore
                    theme={theme.palette.mode}
                    echarts={echarts}
                    option={option}
                    notMerge={true}
                    lazyUpdate={false}
                    style={{ height: 120 }}
                // onEvents={onEvents}
                />
                : null}
        </div>
    );
}

